import CredentialEdit from './CredentialEdit';

export default CredentialEdit;
